export const CdrColorBackgroundAccordionHover = "#fafbf9";
export const CdrColorBackgroundButtonPrimaryRest = "#1f513f";
export const CdrColorBackgroundButtonPrimaryActive = "#1f513f";
export const CdrColorBackgroundButtonPrimaryHover = "#c7dfd1";
export const CdrColorBackgroundButtonPrimaryIconAltHover = "#fafbf9";
export const CdrColorBackgroundButtonSecondaryRest = "#fafbf9";
export const CdrColorBackgroundButtonSecondaryActive = "#958e83";
export const CdrColorBackgroundButtonSecondaryHover = "#f9f8f6";
export const CdrColorBackgroundButtonSecondaryDisabled = "#fafbf9";
export const CdrColorBackgroundButtonDarkRest = "#4b4a48";
export const CdrColorBackgroundButtonDarkActive = "#4b4a48";
export const CdrColorBackgroundButtonDarkHover = "#edeae3";
export const CdrColorBackgroundButtonSaleRest = "#c7370f";
export const CdrColorBackgroundButtonSaleActive = "#c7370f";
export const CdrColorBackgroundButtonSaleHover = "#fde2e2";
export const CdrColorBackgroundButtonDefaultDisabled = "#d5cfc3";
export const CdrColorBackgroundButtonIconOnlyActive = "#f7f5f3";
export const CdrColorBackgroundChipDefaultRest = "#ffffff";
export const CdrColorBackgroundChipDefaultDisabled = "#ffffff";
export const CdrColorBackgroundChipDefaultHover = "#f7f5f3";
export const CdrColorBackgroundChipDefaultFocus = "#ffffff";
export const CdrColorBackgroundChipDefaultActive = "#edeae3";
export const CdrColorBackgroundChipDefaultSelected = "#d5cfc3";
export const CdrColorBackgroundChipDefaultSelectedHover = "#edeae3";
export const CdrColorBackgroundChipDefaultSelectedFocus = "#d5cfc3";
export const CdrColorBackgroundChipDefaultSelectedActive = "#edeae3";
export const CdrColorBackgroundTransparent = "rgba(255, 255, 255, 0)";
export const CdrColorBackgroundPrimary = "#ffffff";
export const CdrColorBackgroundSecondary = "#F4F2ED";
export const CdrColorBackgroundSale = "#c7370f";
export const CdrColorBackgroundBrandSpruce = "#1f513f";
export const CdrColorBackgroundSuccess = "#ecf9e6";
export const CdrColorBackgroundInfo = "#e2f4fe";
export const CdrColorBackgroundWarning = "#fdf6e2";
export const CdrColorBackgroundError = "#fcefe4";
export const CdrColorBackgroundLabelDefaultHover = "#fafbf9";
export const CdrColorBackgroundLabelDefaultActive = "#edeae3";
export const CdrColorBackgroundLabelDefaultFocus = "#fafbf9";
export const CdrColorBackgroundLabelSecondaryHover = "rgba(255, 255, 255, 0.75)";
export const CdrColorBackgroundLabelSecondaryActive = "#ffffff";
export const CdrColorBackgroundLabelSecondaryFocus = "rgba(255, 255, 255, 0.75)";
export const CdrColorBackgroundInputDefault = "rgba(247, 245, 243, 0.15)";
export const CdrColorBackgroundInputSecondary = "rgba(255, 255, 255, 0.85)";
export const CdrColorBackgroundInputError = "rgba(255, 242, 242, 0.75)";
export const CdrColorBackgroundInputDefaultHover = "#fafbf9";
export const CdrColorBackgroundInputDefaultActive = "#fafbf9";
export const CdrColorBackgroundInputDefaultSelected = "#4b4a48";
export const CdrColorBackgroundInputSecondaryActive = "#ffffff";
export const CdrColorBackgroundInputDefaultSelectedHover = "#958e83";
export const CdrColorBackgroundInputDefaultDisabled = "#fafbf9";
export const CdrColorBackgroundInputDefaultSelectedFocus = "#958e83";
export const CdrColorBackgroundInputDefaultFocus = "#fafbf9";
export const CdrColorBackgroundMessageDefault01 = "#f9f8f6";
export const CdrColorBackgroundMessageDefault02 = "#e8e0ce";
export const CdrColorBackgroundMessageSuccess = "#ecf9e6";
export const CdrColorBackgroundMessageSuccess01 = "#f4fbf5";
export const CdrColorBackgroundMessageSuccess02 = "#d5e6cb";
export const CdrColorBackgroundMessageWarning = "#fdf6e2";
export const CdrColorBackgroundMessageWarning01 = "#fefcf1";
export const CdrColorBackgroundMessageWarning02 = "#f5e9b7";
export const CdrColorBackgroundMessageError = "#fcefe4";
export const CdrColorBackgroundMessageError01 = "#fdf7f7";
export const CdrColorBackgroundMessageError02 = "#eecbc1";
export const CdrColorBackgroundMessageInfo = "#e2f4fe";
export const CdrColorBackgroundMessageInfo01 = "#edf4f5";
export const CdrColorBackgroundMessageInfo02 = "#c2d8db";
export const CdrColorBackgroundMessageSale = "#c7370f";
export const CdrColorBackgroundModalOverlay = "rgba(247, 245, 243, 0.85)";
export const CdrColorBackgroundPaginationHover = "#fafbf9";
export const CdrColorBackgroundPaginationKeyline = "#406eb5";
export const CdrColorBackgroundRatingStarDefault = "#fafbf9";
export const CdrColorBackgroundRatingStarHighlighted = "#ffd280";
export const CdrColorBackgroundSlideHover = "#fafbf9";
export const CdrColorBackgroundSlideDefault = "#fafbf9";
export const CdrColorBackgroundSurfaceSelectionDefaultRest = "#ffffff";
export const CdrColorBackgroundSurfaceSelectionDefaultActive = "#ffffff";
export const CdrColorBackgroundSurfaceSelectionDefaultHover = "#ffffff";
export const CdrColorBackgroundSurfaceSelectionDefaultChecked = "#ffffff";
export const CdrColorBackgroundSurfaceSelectionDefaultDisabled = "#f7f5f3";
export const CdrColorBackgroundSurfaceSelectionDefaultLoading = "#fafbf9";
export const CdrColorBackgroundSurfacePrimary = "#ffffff";
export const CdrColorBackgroundSurfaceSecondary = "#f7f5f3";
export const CdrColorBackgroundSurfaceBrandSpruce = "#1f513f";
export const CdrColorBackgroundSurfaceSale = "#c7370f";
export const CdrColorBackgroundSwitchDefaultRest = "#fafbf9";
export const CdrColorBackgroundSwitchDefaultHover = "#fafbf9";
export const CdrColorBackgroundSwitchDefaultFocus = "#fafbf9";
export const CdrColorBackgroundSwitchSelectedDefaultRest = "#4b4a48";
export const CdrColorBackgroundSwitchSelectedDefaultHover = "#2e2e2b";
export const CdrColorBackgroundSwitchSelectedDefaultFocus = "#2e2e2b";
export const CdrColorBackgroundSwitchHandleDefaultRest = "#d5cfc3";
export const CdrColorBackgroundSwitchHandleDefaultHover = "#edeae3";
export const CdrColorBackgroundSwitchHandleDefaultFocus = "#d5cfc3";
export const CdrColorBackgroundSwitchHandleSelectedDefaultRest = "#d5cfc3";
export const CdrColorBackgroundSwitchHandleSelectedDefaultHover = "#d5cfc3";
export const CdrColorBackgroundSwitchHandleSelectedDefaultFocus = "#d5cfc3";
export const CdrColorBackgroundTableHeader = "#f7f5f3";
export const CdrColorBackgroundTableRow = "#ffffff";
export const CdrColorBackgroundTableRowAlt = "#fafbf9";
export const CdrColorBackgroundToggleGroupDefaultRest = "#fafbf9";
export const CdrColorBackgroundToggleButtonDefaultRest = "#fafbf9";
export const CdrColorBackgroundToggleButtonDefaultHover = "#edeae3";
export const CdrColorBackgroundToggleButtonDefaultFocus = "#edeae3";
export const CdrColorBackgroundToggleButtonDefaultSelectedRest = "#ffffff";
export const CdrColorBackgroundToggleButtonDefaultSelectedHover = "#ffffff";
export const CdrColorBackgroundTooltipDefault = "#2e2e2b";
export const CdrColorTextButtonPrimary = "#fafbf9";
export const CdrColorTextButtonPrimaryHover = "#1f513f";
export const CdrColorTextButtonPrimaryActive = "#fafbf9";
export const CdrColorTextButtonPrimaryDisabled = "#ffffff";
export const CdrColorTextButtonSecondary = "#4b4a48";
export const CdrColorTextButtonSecondaryHover = "#4b4a48";
export const CdrColorTextButtonSecondaryActive = "#fafbf9";
export const CdrColorTextButtonSecondaryDisabled = "#d5cfc3";
export const CdrColorTextButtonDark = "#fafbf9";
export const CdrColorTextButtonDarkHover = "#4b4a48";
export const CdrColorTextButtonDarkActive = "#fafbf9";
export const CdrColorTextButtonDarkDisabled = "#ffffff";
export const CdrColorTextButtonSale = "#ffffff";
export const CdrColorTextButtonSaleHover = "#c7370f";
export const CdrColorTextButtonSaleActive = "#ffffff";
export const CdrColorTextButtonSaleDisabled = "#ffffff";
export const CdrColorTextChipDefault = "#4b4a48";
export const CdrColorTextChipDisabled = "#d5cfc3";
export const CdrColorTextPrimary = "#4b4a48";
export const CdrColorTextSecondary = "#736e65";
export const CdrColorTextEmphasis = "#2e2e2b";
export const CdrColorTextBrand = "#1f513f";
export const CdrColorTextSale = "#c7370f";
export const CdrColorTextInverse = "#fafbf9";
export const CdrColorTextDisabled = "#d5cfc3";
export const CdrColorTextSuccess = "#2e6b34";
export const CdrColorTextWarning = "#854714";
export const CdrColorTextError = "#811823";
export const CdrColorTextInfo = "#1b437e";
export const CdrColorTextInputDefault = "#2e2e2b";
export const CdrColorTextInputLabel = "#4b4a48";
export const CdrColorTextInputLabelDisabled = "#b2ab9f";
export const CdrColorTextInputPlaceholder = "#736e65";
export const CdrColorTextInputRequired = "#4b4a48";
export const CdrColorTextInputOptional = "#736e65";
export const CdrColorTextInputDisabled = "#d5cfc3";
export const CdrColorTextInputFilled = "#2e2e2b";
export const CdrColorTextInputHelp = "#736e65";
export const CdrColorTextInputError = "#b33322";
export const CdrColorTextLinkRest = "#406eb5";
export const CdrColorTextLinkHover = "#406eb5";
export const CdrColorTextLinkActive = "#0b2d60";
export const CdrColorTextLinkDisabled = "#d5cfc3";
export const CdrColorTextLinkVisited = "#406eb5";
export const CdrColorTextMessageError = "#bb4045";
export const CdrColorTextRatingDefault = "#4b4a48";
export const CdrColorTextRatingHover = "#406eb5";
export const CdrColorTextRatingSeparator = "#b2ab9f";
export const CdrColorTextTabRest = "#736e65";
export const CdrColorTextTabActive = "#4b4a48";
export const CdrColorTextTabHover = "#406eb5";
export const CdrColorTextTabDisabled = "#d5cfc3";
export const CdrColorTextToggleButtonDefaultRest = "#4b4a48";
export const CdrColorTextTooltipDefault = "#fafbf9";
export const CdrColorBorderButtonPrimaryRest = "#1f513f";
export const CdrColorBorderButtonPrimaryActive = "#1f513f";
export const CdrColorBorderButtonPrimaryActiveInset = "#f7f5f3";
export const CdrColorBorderButtonPrimaryHover = "#1f513f";
export const CdrColorBorderButtonSecondaryRest = "#958e83";
export const CdrColorBorderButtonSecondaryActive = "#958e83";
export const CdrColorBorderButtonSecondaryActiveInset = "#f7f5f3";
export const CdrColorBorderButtonSecondaryHover = "#4b4a48";
export const CdrColorBorderButtonDarkRest = "#4b4a48";
export const CdrColorBorderButtonDarkActive = "#4b4a48";
export const CdrColorBorderButtonDarkActiveInset = "#edeae3";
export const CdrColorBorderButtonDarkHover = "#4b4a48";
export const CdrColorBorderButtonSaleRest = "#c7370f";
export const CdrColorBorderButtonSaleActive = "#c7370f";
export const CdrColorBorderButtonSaleActiveInset = "#fde2e2";
export const CdrColorBorderButtonSaleHover = "#c7370f";
export const CdrColorBorderButtonDefaultDisabled = "#d5cfc3";
export const CdrColorBorderButtonIconOnlyActive = "#958e83";
export const CdrColorBorderChipDefaultRest = "#958e83";
export const CdrColorBorderChipDefaultDisabled = "#d5cfc3";
export const CdrColorBorderChipDefaultHover = "#958e83";
export const CdrColorBorderChipDefaultFocus = "#4b4a48";
export const CdrColorBorderChipDefaultActive = "#4b4a48";
export const CdrColorBorderChipDefaultSelectedRest = "#4b4a48";
export const CdrColorBorderChipDefaultSelectedHover = "#736e65";
export const CdrColorBorderChipDefaultSelectedFocus = "#4b4a48";
export const CdrColorBorderTransparent = "rgba(255, 255, 255, 0)";
export const CdrColorBorderPrimary = "#d5cfc3";
export const CdrColorBorderSecondary = "#958e83";
export const CdrColorBorderSuccess = "#3b8349";
export const CdrColorBorderWarning = "#b68b37";
export const CdrColorBorderError = "#bb4045";
export const CdrColorBorderInfo = "#406eb5";
export const CdrColorBorderLabelDefaultFocus = "#2e2e2b";
export const CdrColorBorderInputDefault = "#958e83";
export const CdrColorBorderInputError = "#b33322";
export const CdrColorBorderInputDefaultActive = "#4b4a48";
export const CdrColorBorderInputDefaultSelected = "#4b4a48";
export const CdrColorBorderInputDefaultFocus = "#2e2e2b";
export const CdrColorBorderInputDefaultSelectedHover = "#4b4a48";
export const CdrColorBorderInputDefaultHover = "#2e2e2b";
export const CdrColorBorderInputDefaultDisabled = "#d5cfc3";
export const CdrColorBorderLinkRest = "#406eb5";
export const CdrColorBorderLinkHover = "#406eb5";
export const CdrColorBorderLinkActive = "#0b2d60";
export const CdrColorBorderLinkDisabled = "#d5cfc3";
export const CdrColorBorderLinkVisited = "#406eb5";
export const CdrColorBorderMessageDefault01 = "#726d64";
export const CdrColorBorderMessageDefault02 = "#e8e0ce";
export const CdrColorBorderMessageSuccess01 = "#3b8349";
export const CdrColorBorderMessageSuccess02 = "#d5e6cb";
export const CdrColorBorderMessageWarning01 = "#b68b37";
export const CdrColorBorderMessageWarning02 = "#f5e9b7";
export const CdrColorBorderMessageError01 = "#bb4045";
export const CdrColorBorderMessageError02 = "#eecbc1";
export const CdrColorBorderMessageInfo01 = "#408e86";
export const CdrColorBorderMessageInfo02 = "#c2d8db";
export const CdrColorBorderRatingStarDefault = "#958e83";
export const CdrColorBorderRatingStarHighlighted = "#bd7b2d";
export const CdrColorBorderSurfaceSelectionDefaultRest = "#958e83";
export const CdrColorBorderSurfaceSelectionDefaultActive = "#958e83";
export const CdrColorBorderSurfaceSelectionDefaultHover = "#958e83";
export const CdrColorBorderSurfaceSelectionDefaultChecked = "#2e2e2b";
export const CdrColorBorderSurfaceSelectionDefaultDisabled = "#958e83";
export const CdrColorBorderSurfaceSelectionDefaultLoading = "#958e83";
export const CdrColorBorderSurfacePrimary = "#d5cfc3";
export const CdrColorBorderSurfaceSecondary = "#958e83";
export const CdrColorBorderSurfaceSuccess = "#3b8349";
export const CdrColorBorderSurfaceWarning = "#b68b37";
export const CdrColorBorderSurfaceError = "#bb4045";
export const CdrColorBorderSurfaceInfo = "#406eb5";
export const CdrColorBorderSwitchDefaultHover = "#4b4a48";
export const CdrColorBorderSwitchHandleDefaultRest = "#d5cfc3";
export const CdrColorBorderSwitchHandleDefaultHover = "#4b4a48";
export const CdrColorBorderSwitchHandleDefaultFocus = "#d5cfc3";
export const CdrColorBorderTabKeylineRest = "#958e83";
export const CdrColorBorderTabKeylineActive = "#406eb5";
export const CdrColorBorderTabKeylineActiveAlt = "#78b1e8";
export const CdrColorBorderTabKeylineHover = "#406eb5";
export const CdrColorBorderTabKeylineHoverAlt = "#78b1e8";
export const CdrColorBorderTabKeylineDisabled = "#d5cfc3";
export const CdrColorBorderTableDefault = "#d5cfc3";
export const CdrColorBorderTableHead = "#958e83";
export const CdrColorBorderToggleButtonDefaultFocus = "#4b4a48";
export const CdrColorBorderToggleButtonDefaultSelectedRest = "#4b4a48";
export const CdrColorBorderToggleButtonDefaultSelectedFocus = "#4b4a48";
export const CdrColorBorderTooltipDefault = "#fafbf9";
export const CdrColorIconDefault = "#958e83";
export const CdrColorIconEmphasis = "#4b4a48";
export const CdrColorIconLink = "#406eb5";
export const CdrColorIconDisabled = "#d5cfc3";
export const CdrColorIconCheckboxDefaultSelected = "#ffffff";
export const CdrColorIconCheckboxDefaultSelectedHover = "#ffffff";
export const CdrColorIconCheckboxDefaultSelectedActive = "#4b4a48";
export const CdrColorIconMessageDefault = "#726d64";
export const CdrColorIconMessageSuccess = "#3b8349";
export const CdrColorIconMessageWarning = "#b68b37";
export const CdrColorIconMessageError = "#bb4045";
export const CdrColorIconMessageInfo = "#408e86";
export const CdrColorIconSwitchSelectedDefaultRest = "#d5cfc3";
export const CdrColorIconSwitchSelectedDefaultHover = "#d5cfc3";
export const CdrColorIconSwitchSelectedDefaultFocus = "#d5cfc3";
export const CdrFormInputHeightDefault = "40";
export const CdrFormInputHeightLarge = "48";
export const CdrFormFigureSizeSmall = "16";
export const CdrFormFigureSizeMedium = "16";
export const CdrFormFigureSizeLarge = "20";
export const CdrIconSizeSm = "16";
export const CdrIconSize = "24";
export const CdrIconSizeLg = "32";
export const CdrDuration1X = "100ms";
export const CdrDuration2X = "200ms";
export const CdrDuration3X = "300ms";
export const CdrDuration4X = "400ms";
export const CdrDuration5X = "500ms";
export const CdrDuration6X = "600ms";
export const CdrTimingFunctionEaseOut = "cubic-bezier(0.32, 0.94, 0.60, 1)";
export const CdrTimingFunctionEase = "cubic-bezier(0.15, 0, 0.15, 0)";
export const CdrTimingFunctionLinear = "cubic-bezier(0, 0, 1, 1)";
export const CdrProminenceFlatX = "0";
export const CdrProminenceFlatY = "0";
export const CdrProminenceFlatBlur = "0";
export const CdrProminenceFlatSpread = "0";
export const CdrProminenceFlatColor = "rgba(46, 46, 43, 0.2)";
export const CdrProminenceRaisedX = "0";
export const CdrProminenceRaisedY = "2px";
export const CdrProminenceRaisedBlur = "2px";
export const CdrProminenceRaisedSpread = "0";
export const CdrProminenceRaisedColor = "rgba(46, 46, 43, 0.2)";
export const CdrProminenceElevatedX = "0";
export const CdrProminenceElevatedY = "4px";
export const CdrProminenceElevatedBlur = "4px";
export const CdrProminenceElevatedSpread = "0";
export const CdrProminenceElevatedColor = "rgba(46, 46, 43, 0.2)";
export const CdrProminenceFloatingX = "0";
export const CdrProminenceFloatingY = "8px";
export const CdrProminenceFloatingBlur = "8px";
export const CdrProminenceFloatingSpread = "0";
export const CdrProminenceFloatingColor = "rgba(46, 46, 43, 0.2)";
export const CdrProminenceLiftedX = "0";
export const CdrProminenceLiftedY = "16px";
export const CdrProminenceLiftedBlur = "16px";
export const CdrProminenceLiftedSpread = "0";
export const CdrProminenceLiftedColor = "rgba(46, 46, 43, 0.2)";
export const CdrProminenceFlat = "0 0 0 0 rgba(46, 46, 43, 0.2)";
export const CdrProminenceRaised = "0 2px 2px 0 rgba(46, 46, 43, 0.2)";
export const CdrProminenceElevated = "0 4px 4px 0 rgba(46, 46, 43, 0.2)";
export const CdrProminenceFloating = "0 8px 8px 0 rgba(46, 46, 43, 0.2)";
export const CdrProminenceLifted = "0 16px 16px 0 rgba(46, 46, 43, 0.2)";
export const CdrRadiusSharp = "0";
export const CdrRadiusSoft = "2";
export const CdrRadiusSofter = "4";
export const CdrRadiusSoftest = "6";
export const CdrRadiusRound = "9999";
export const CdrSpaceZero = "0";
export const CdrSpaceSixteenthX = "1";
export const CdrSpaceEighthX = "2";
export const CdrSpaceThreeSixteenthX = "3";
export const CdrSpaceQuarterX = "4";
export const CdrSpaceThreeEighthX = "6";
export const CdrSpaceHalfX = "8";
export const CdrSpaceThreeQuarterX = "12";
export const CdrSpaceOneX = "16";
export const CdrSpaceOneAndAHalfX = "24";
export const CdrSpaceTwoX = "32";
export const CdrSpaceThreeX = "48";
export const CdrSpaceFourX = "64";
export const CdrSpaceInsetSixteenthX = "1";
export const CdrSpaceInsetEighthX = "2";
export const CdrSpaceInsetEighthXSquishTopBottom = "0";
export const CdrSpaceInsetEighthXSquishLeftRight = "2";
export const CdrSpaceInsetEighthXStretchTopBottom = "4";
export const CdrSpaceInsetEighthXStretchLeftRight = "2";
export const CdrSpaceInsetThreeSixteenthX = "3";
export const CdrSpaceInsetQuarterX = "4";
export const CdrSpaceInsetQuarterXSquishTopBottom = "2";
export const CdrSpaceInsetQuarterXSquishLeftRight = "4";
export const CdrSpaceInsetQuarterXStretchTopBottom = "6";
export const CdrSpaceInsetQuarterXStretchLeftRight = "4";
export const CdrSpaceInsetThreeEighthX = "6";
export const CdrSpaceInsetHalfX = "8";
export const CdrSpaceInsetHalfXSquishTopBottom = "4";
export const CdrSpaceInsetHalfXSquishLeftRight = "8";
export const CdrSpaceInsetHalfXStretchTopBottom = "12";
export const CdrSpaceInsetHalfXStretchLeftRight = "8";
export const CdrSpaceInsetThreeQuarterX = "12";
export const CdrSpaceInsetThreeQuarterXSquishTopBottom = "6";
export const CdrSpaceInsetThreeQuarterXSquishLeftRight = "12";
export const CdrSpaceInsetThreeQuarterXStretchTopBottom = "18";
export const CdrSpaceInsetThreeQuarterXStretchLeftRight = "12";
export const CdrSpaceInsetOneX = "16";
export const CdrSpaceInsetOneXSquishTopBottom = "8";
export const CdrSpaceInsetOneXSquishLeftRight = "16";
export const CdrSpaceInsetOneXStretchTopBottom = "24";
export const CdrSpaceInsetOneXStretchLeftRight = "16";
export const CdrSpaceInsetOneAndAHalfX = "24";
export const CdrSpaceInsetOneAndAHalfXSquishTopBottom = "12";
export const CdrSpaceInsetOneAndAHalfXSquishLeftRight = "24";
export const CdrSpaceInsetOneAndAHalfXStretchTopBottom = "36";
export const CdrSpaceInsetOneAndAHalfXStretchLeftRight = "24";
export const CdrSpaceInsetTwoX = "32";
export const CdrSpaceInsetTwoXSquishTopBottom = "16";
export const CdrSpaceInsetTwoXSquishLeftRight = "32";
export const CdrSpaceInsetTwoXStretchTopBottom = "48";
export const CdrSpaceInsetTwoXStretchLeftRight = "32";
export const CdrSpaceInsetThreeX = "48";
export const CdrSpaceInsetThreeXSquishTopBottom = "24";
export const CdrSpaceInsetThreeXSquishLeftRight = "48";
export const CdrSpaceInsetThreeXStretchTopBottom = "72";
export const CdrSpaceInsetThreeXStretchLeftRight = "48";
export const CdrSpaceInsetFourX = "64";
export const CdrSpaceInsetFourXSquishTopBottom = "32";
export const CdrSpaceInsetFourXSquishLeftRight = "64";
export const CdrSpaceInsetFourXStretchTopBottom = "96";
export const CdrSpaceInsetFourXStretchLeftRight = "64";
export const CdrSpaceInsetEighthXSquish = "0 2";
export const CdrSpaceInsetEighthXStretch = "4 2";
export const CdrSpaceInsetQuarterXSquish = "2 4";
export const CdrSpaceInsetQuarterXStretch = "6 4";
export const CdrSpaceInsetHalfXSquish = "4 8";
export const CdrSpaceInsetHalfXStretch = "12 8";
export const CdrSpaceInsetThreeQuarterXSquish = "6 12";
export const CdrSpaceInsetThreeQuarterXStretch = "18 12";
export const CdrSpaceInsetOneXSquish = "8 16";
export const CdrSpaceInsetOneXStretch = "24 16";
export const CdrSpaceInsetOneAndAHalfXSquish = "12 24";
export const CdrSpaceInsetOneAndAHalfXStretch = "36 24";
export const CdrSpaceInsetTwoXSquish = "16 32";
export const CdrSpaceInsetTwoXStretch = "48 32";
export const CdrSpaceInsetThreeXSquish = "24 48";
export const CdrSpaceInsetThreeXStretch = "72 48";
export const CdrSpaceInsetFourXSquish = "32 64";
export const CdrSpaceInsetFourXStretch = "96 64";
export const CdrBreakpointXs = "0";
export const CdrBreakpointSm = "768";
export const CdrBreakpointMd = "992";
export const CdrBreakpointLg = "1232";
export const CdrFontFamilySerifBrandFont = "Stuart";
export const CdrFontFamilySerif = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrFontFamilySansBrandFont = "Graphik";
export const CdrFontFamilySans = "Graphik, \"Graphik fallback\", \"Helvetica Neue\", sans-serif";
export const CdrFontFamilyMonoBrandFont = "Pressura,  \"Avenir Next\", Roboto, sans-serif";
export const CdrTextBody300Family = "Graphik, \"Graphik fallback\", \"Helvetica Neue\", sans-serif";
export const CdrTextBody300Style = "normal";
export const CdrTextBody300Weight = "400";
export const CdrTextBody300Spacing = "0.08";
export const CdrTextBody300Size = "16";
export const CdrTextBody300Height = "26";
export const CdrTextBody400Family = "Graphik, \"Graphik fallback\", \"Helvetica Neue\", sans-serif";
export const CdrTextBody400Style = "normal";
export const CdrTextBody400Weight = "400";
export const CdrTextBody400Spacing = "0";
export const CdrTextBody400Size = "18";
export const CdrTextBody400Height = "30";
export const CdrTextBody500Family = "Graphik, \"Graphik fallback\", \"Helvetica Neue\", sans-serif";
export const CdrTextBody500Style = "normal";
export const CdrTextBody500Weight = "400";
export const CdrTextBody500Spacing = "-0.16";
export const CdrTextBody500Size = "20";
export const CdrTextBody500Height = "36";
export const CdrTextBodyStrong300Family = "Graphik, \"Graphik fallback\", \"Helvetica Neue\", sans-serif";
export const CdrTextBodyStrong300Style = "normal";
export const CdrTextBodyStrong300Weight = "600";
export const CdrTextBodyStrong300Spacing = "0.08";
export const CdrTextBodyStrong300Size = "16";
export const CdrTextBodyStrong300Height = "26";
export const CdrTextBodyStrong400Family = "Graphik, \"Graphik fallback\", \"Helvetica Neue\", sans-serif";
export const CdrTextBodyStrong400Style = "normal";
export const CdrTextBodyStrong400Weight = "600";
export const CdrTextBodyStrong400Spacing = "0";
export const CdrTextBodyStrong400Size = "18";
export const CdrTextBodyStrong400Height = "30";
export const CdrTextBodyStrong500Family = "Graphik, \"Graphik fallback\", \"Helvetica Neue\", sans-serif";
export const CdrTextBodyStrong500Style = "normal";
export const CdrTextBodyStrong500Weight = "600";
export const CdrTextBodyStrong500Spacing = "-0.08";
export const CdrTextBodyStrong500Size = "20";
export const CdrTextBodyStrong500Height = "36";
export const CdrTextDefaultFamily = "Graphik, \"Graphik fallback\", \"Helvetica Neue\", sans-serif";
export const CdrTextDefaultStyle = "normal";
export const CdrTextDefaultWeight = "400";
export const CdrTextDefaultSpacing = "-0.16";
export const CdrTextDefaultSize = "16";
export const CdrTextDefaultHeight = "22";
export const CdrTextEyebrow100Family = "Graphik, \"Graphik fallback\", \"Helvetica Neue\", sans-serif";
export const CdrTextEyebrow100Style = "normal";
export const CdrTextEyebrow100Weight = "500";
export const CdrTextEyebrow100Spacing = "0.32";
export const CdrTextEyebrow100Size = "12";
export const CdrTextEyebrow100Height = "18";
export const CdrTextEyebrow100Transform = "uppercase";
export const CdrTextHeadingSans200Family = "Graphik, \"Graphik fallback\", \"Helvetica Neue\", sans-serif";
export const CdrTextHeadingSans200Style = "normal";
export const CdrTextHeadingSans200Weight = "500";
export const CdrTextHeadingSans200Spacing = "0";
export const CdrTextHeadingSans200Size = "14";
export const CdrTextHeadingSans200Height = "18";
export const CdrTextHeadingSans300Family = "Graphik, \"Graphik fallback\", \"Helvetica Neue\", sans-serif";
export const CdrTextHeadingSans300Style = "normal";
export const CdrTextHeadingSans300Weight = "500";
export const CdrTextHeadingSans300Spacing = "0";
export const CdrTextHeadingSans300Size = "16";
export const CdrTextHeadingSans300Height = "20";
export const CdrTextHeadingSans400Family = "Graphik, \"Graphik fallback\", \"Helvetica Neue\", sans-serif";
export const CdrTextHeadingSans400Style = "normal";
export const CdrTextHeadingSans400Weight = "500";
export const CdrTextHeadingSans400Spacing = "0";
export const CdrTextHeadingSans400Size = "18";
export const CdrTextHeadingSans400Height = "24";
export const CdrTextHeadingSans500Family = "Graphik, \"Graphik fallback\", \"Helvetica Neue\", sans-serif";
export const CdrTextHeadingSans500Style = "normal";
export const CdrTextHeadingSans500Weight = "500";
export const CdrTextHeadingSans500Spacing = "0";
export const CdrTextHeadingSans500Size = "20";
export const CdrTextHeadingSans500Height = "26";
export const CdrTextHeadingSans600Family = "Graphik, \"Graphik fallback\", \"Helvetica Neue\", sans-serif";
export const CdrTextHeadingSans600Style = "normal";
export const CdrTextHeadingSans600Weight = "500";
export const CdrTextHeadingSans600Spacing = "0";
export const CdrTextHeadingSans600Size = "24";
export const CdrTextHeadingSans600Height = "30";
export const CdrTextHeadingSerif200Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextHeadingSerif200Style = "normal";
export const CdrTextHeadingSerif200Weight = "500";
export const CdrTextHeadingSerif200Spacing = "0";
export const CdrTextHeadingSerif200Size = "14";
export const CdrTextHeadingSerif200Height = "18";
export const CdrTextHeadingSerif300Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextHeadingSerif300Style = "normal";
export const CdrTextHeadingSerif300Weight = "500";
export const CdrTextHeadingSerif300Spacing = "0";
export const CdrTextHeadingSerif300Size = "16";
export const CdrTextHeadingSerif300Height = "20";
export const CdrTextHeadingSerif400Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextHeadingSerif400Style = "normal";
export const CdrTextHeadingSerif400Weight = "500";
export const CdrTextHeadingSerif400Spacing = "0";
export const CdrTextHeadingSerif400Size = "18";
export const CdrTextHeadingSerif400Height = "24";
export const CdrTextHeadingSerif500Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextHeadingSerif500Style = "normal";
export const CdrTextHeadingSerif500Weight = "500";
export const CdrTextHeadingSerif500Spacing = "0";
export const CdrTextHeadingSerif500Size = "20";
export const CdrTextHeadingSerif500Height = "26";
export const CdrTextHeadingSerif600Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextHeadingSerif600Style = "normal";
export const CdrTextHeadingSerif600Weight = "500";
export const CdrTextHeadingSerif600Spacing = "0";
export const CdrTextHeadingSerif600Size = "24";
export const CdrTextHeadingSerif600Height = "30";
export const CdrTextHeadingSerif700Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextHeadingSerif700Style = "normal";
export const CdrTextHeadingSerif700Weight = "500";
export const CdrTextHeadingSerif700Spacing = "0";
export const CdrTextHeadingSerif700Size = "28";
export const CdrTextHeadingSerif700Height = "32";
export const CdrTextHeadingSerif800Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextHeadingSerif800Style = "normal";
export const CdrTextHeadingSerif800Weight = "500";
export const CdrTextHeadingSerif800Spacing = "0";
export const CdrTextHeadingSerif800Size = "32";
export const CdrTextHeadingSerif800Height = "36";
export const CdrTextHeadingSerif900Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextHeadingSerif900Style = "normal";
export const CdrTextHeadingSerif900Weight = "500";
export const CdrTextHeadingSerif900Spacing = "0";
export const CdrTextHeadingSerif900Size = "36";
export const CdrTextHeadingSerif900Height = "44";
export const CdrTextHeadingSerif1000Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextHeadingSerif1000Style = "normal";
export const CdrTextHeadingSerif1000Weight = "500";
export const CdrTextHeadingSerif1000Spacing = "0";
export const CdrTextHeadingSerif1000Size = "42";
export const CdrTextHeadingSerif1000Height = "50";
export const CdrTextHeadingSerif1100Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextHeadingSerif1100Style = "normal";
export const CdrTextHeadingSerif1100Weight = "500";
export const CdrTextHeadingSerif1100Spacing = "0";
export const CdrTextHeadingSerif1100Size = "48";
export const CdrTextHeadingSerif1100Height = "56";
export const CdrTextHeadingSerif1200Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextHeadingSerif1200Style = "normal";
export const CdrTextHeadingSerif1200Weight = "500";
export const CdrTextHeadingSerif1200Spacing = "0";
export const CdrTextHeadingSerif1200Size = "54";
export const CdrTextHeadingSerif1200Height = "64";
export const CdrTextHeadingSerifStrong600Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextHeadingSerifStrong600Style = "normal";
export const CdrTextHeadingSerifStrong600Weight = "600";
export const CdrTextHeadingSerifStrong600Spacing = "0";
export const CdrTextHeadingSerifStrong600Size = "24";
export const CdrTextHeadingSerifStrong600Height = "30";
export const CdrTextHeadingSerifStrong700Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextHeadingSerifStrong700Style = "normal";
export const CdrTextHeadingSerifStrong700Weight = "600";
export const CdrTextHeadingSerifStrong700Spacing = "0";
export const CdrTextHeadingSerifStrong700Size = "28";
export const CdrTextHeadingSerifStrong700Height = "32";
export const CdrTextHeadingSerifStrong800Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextHeadingSerifStrong800Style = "normal";
export const CdrTextHeadingSerifStrong800Weight = "600";
export const CdrTextHeadingSerifStrong800Spacing = "0";
export const CdrTextHeadingSerifStrong800Size = "32";
export const CdrTextHeadingSerifStrong800Height = "36";
export const CdrTextHeadingSerifStrong900Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextHeadingSerifStrong900Style = "normal";
export const CdrTextHeadingSerifStrong900Weight = "600";
export const CdrTextHeadingSerifStrong900Spacing = "0";
export const CdrTextHeadingSerifStrong900Size = "36";
export const CdrTextHeadingSerifStrong900Height = "44";
export const CdrTextHeadingSerifStrong1000Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextHeadingSerifStrong1000Style = "normal";
export const CdrTextHeadingSerifStrong1000Weight = "600";
export const CdrTextHeadingSerifStrong1000Spacing = "0";
export const CdrTextHeadingSerifStrong1000Size = "42";
export const CdrTextHeadingSerifStrong1000Height = "50";
export const CdrTextHeadingSerifStrong1100Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextHeadingSerifStrong1100Style = "normal";
export const CdrTextHeadingSerifStrong1100Weight = "600";
export const CdrTextHeadingSerifStrong1100Spacing = "0";
export const CdrTextHeadingSerifStrong1100Size = "48";
export const CdrTextHeadingSerifStrong1100Height = "56";
export const CdrTextHeadingSerifStrong1200Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextHeadingSerifStrong1200Style = "normal";
export const CdrTextHeadingSerifStrong1200Weight = "600";
export const CdrTextHeadingSerifStrong1200Spacing = "0";
export const CdrTextHeadingSerifStrong1200Size = "54";
export const CdrTextHeadingSerifStrong1200Height = "64";
export const CdrTextHeadingDisplay800Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextHeadingDisplay800Style = "normal";
export const CdrTextHeadingDisplay800Weight = "400";
export const CdrTextHeadingDisplay800Spacing = "0";
export const CdrTextHeadingDisplay800Size = "32";
export const CdrTextHeadingDisplay800Height = "36";
export const CdrTextHeadingDisplay900Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextHeadingDisplay900Style = "normal";
export const CdrTextHeadingDisplay900Weight = "400";
export const CdrTextHeadingDisplay900Spacing = "0";
export const CdrTextHeadingDisplay900Size = "36";
export const CdrTextHeadingDisplay900Height = "40";
export const CdrTextHeadingDisplay1000Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextHeadingDisplay1000Style = "normal";
export const CdrTextHeadingDisplay1000Weight = "400";
export const CdrTextHeadingDisplay1000Spacing = "0";
export const CdrTextHeadingDisplay1000Size = "42";
export const CdrTextHeadingDisplay1000Height = "48";
export const CdrTextHeadingDisplay1100Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextHeadingDisplay1100Style = "normal";
export const CdrTextHeadingDisplay1100Weight = "400";
export const CdrTextHeadingDisplay1100Spacing = "0";
export const CdrTextHeadingDisplay1100Size = "48";
export const CdrTextHeadingDisplay1100Height = "52";
export const CdrTextHeadingDisplay1200Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextHeadingDisplay1200Style = "normal";
export const CdrTextHeadingDisplay1200Weight = "400";
export const CdrTextHeadingDisplay1200Spacing = "0";
export const CdrTextHeadingDisplay1200Size = "54";
export const CdrTextHeadingDisplay1200Height = "60";
export const CdrTextHeadingDisplay1300Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextHeadingDisplay1300Style = "normal";
export const CdrTextHeadingDisplay1300Weight = "400";
export const CdrTextHeadingDisplay1300Spacing = "0";
export const CdrTextHeadingDisplay1300Size = "60";
export const CdrTextHeadingDisplay1300Height = "64";
export const CdrTextHeadingDisplay1400Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextHeadingDisplay1400Style = "normal";
export const CdrTextHeadingDisplay1400Weight = "400";
export const CdrTextHeadingDisplay1400Spacing = "0";
export const CdrTextHeadingDisplay1400Size = "68";
export const CdrTextHeadingDisplay1400Height = "72";
export const CdrTextHeadingDisplay1500Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextHeadingDisplay1500Style = "normal";
export const CdrTextHeadingDisplay1500Weight = "400";
export const CdrTextHeadingDisplay1500Spacing = "0";
export const CdrTextHeadingDisplay1500Size = "76";
export const CdrTextHeadingDisplay1500Height = "80";
export const CdrTextHeadingDisplay1600Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextHeadingDisplay1600Style = "normal";
export const CdrTextHeadingDisplay1600Weight = "400";
export const CdrTextHeadingDisplay1600Spacing = "0";
export const CdrTextHeadingDisplay1600Size = "86";
export const CdrTextHeadingDisplay1600Height = "92";
export const CdrTextSubheadingSans300Family = "Graphik, \"Graphik fallback\", \"Helvetica Neue\", sans-serif";
export const CdrTextSubheadingSans300Style = "normal";
export const CdrTextSubheadingSans300Weight = "500";
export const CdrTextSubheadingSans300Spacing = "0";
export const CdrTextSubheadingSans300Size = "16";
export const CdrTextSubheadingSans300Height = "20";
export const CdrTextSubheadingSans400Family = "Graphik, \"Graphik fallback\", \"Helvetica Neue\", sans-serif";
export const CdrTextSubheadingSans400Style = "normal";
export const CdrTextSubheadingSans400Weight = "500";
export const CdrTextSubheadingSans400Spacing = "0";
export const CdrTextSubheadingSans400Size = "18";
export const CdrTextSubheadingSans400Height = "24";
export const CdrTextSubheadingSans500Family = "Graphik, \"Graphik fallback\", \"Helvetica Neue\", sans-serif";
export const CdrTextSubheadingSans500Style = "normal";
export const CdrTextSubheadingSans500Weight = "500";
export const CdrTextSubheadingSans500Spacing = "0";
export const CdrTextSubheadingSans500Size = "20";
export const CdrTextSubheadingSans500Height = "26";
export const CdrTextSubheadingSans600Family = "Graphik, \"Graphik fallback\", \"Helvetica Neue\", sans-serif";
export const CdrTextSubheadingSans600Style = "normal";
export const CdrTextSubheadingSans600Weight = "500";
export const CdrTextSubheadingSans600Spacing = "0";
export const CdrTextSubheadingSans600Size = "24";
export const CdrTextSubheadingSans600Height = "30";
export const CdrTextUtilitySans100Family = "Graphik, \"Graphik fallback\", \"Helvetica Neue\", sans-serif";
export const CdrTextUtilitySans100Style = "normal";
export const CdrTextUtilitySans100Weight = "400";
export const CdrTextUtilitySans100Spacing = "-0.08";
export const CdrTextUtilitySans100Size = "12";
export const CdrTextUtilitySans100Height = "16";
export const CdrTextUtilitySans200Family = "Graphik, \"Graphik fallback\", \"Helvetica Neue\", sans-serif";
export const CdrTextUtilitySans200Style = "normal";
export const CdrTextUtilitySans200Weight = "400";
export const CdrTextUtilitySans200Spacing = "-0.16";
export const CdrTextUtilitySans200Size = "14";
export const CdrTextUtilitySans200Height = "18";
export const CdrTextUtilitySans300Family = "Graphik, \"Graphik fallback\", \"Helvetica Neue\", sans-serif";
export const CdrTextUtilitySans300Style = "normal";
export const CdrTextUtilitySans300Weight = "400";
export const CdrTextUtilitySans300Spacing = "-0.16";
export const CdrTextUtilitySans300Size = "16";
export const CdrTextUtilitySans300Height = "22";
export const CdrTextUtilitySans400Family = "Graphik, \"Graphik fallback\", \"Helvetica Neue\", sans-serif";
export const CdrTextUtilitySans400Style = "normal";
export const CdrTextUtilitySans400Weight = "400";
export const CdrTextUtilitySans400Spacing = "-0.16";
export const CdrTextUtilitySans400Size = "18";
export const CdrTextUtilitySans400Height = "24";
export const CdrTextUtilitySans500Family = "Graphik, \"Graphik fallback\", \"Helvetica Neue\", sans-serif";
export const CdrTextUtilitySans500Style = "normal";
export const CdrTextUtilitySans500Weight = "400";
export const CdrTextUtilitySans500Spacing = "-0.32";
export const CdrTextUtilitySans500Size = "20";
export const CdrTextUtilitySans500Height = "26";
export const CdrTextUtilitySans600Family = "Graphik, \"Graphik fallback\", \"Helvetica Neue\", sans-serif";
export const CdrTextUtilitySans600Style = "normal";
export const CdrTextUtilitySans600Weight = "400";
export const CdrTextUtilitySans600Spacing = "-0.32";
export const CdrTextUtilitySans600Size = "24";
export const CdrTextUtilitySans600Height = "30";
export const CdrTextUtilitySans700Family = "Graphik, \"Graphik fallback\", \"Helvetica Neue\", sans-serif";
export const CdrTextUtilitySans700Style = "normal";
export const CdrTextUtilitySans700Weight = "400";
export const CdrTextUtilitySans700Spacing = "-0.32";
export const CdrTextUtilitySans700Size = "28";
export const CdrTextUtilitySans700Height = "36";
export const CdrTextUtilitySans800Family = "Graphik, \"Graphik fallback\", \"Helvetica Neue\", sans-serif";
export const CdrTextUtilitySans800Style = "normal";
export const CdrTextUtilitySans800Weight = "400";
export const CdrTextUtilitySans800Spacing = "-0.64";
export const CdrTextUtilitySans800Size = "32";
export const CdrTextUtilitySans800Height = "40";
export const CdrTextUtilitySansStrong100Family = "Graphik, \"Graphik fallback\", \"Helvetica Neue\", sans-serif";
export const CdrTextUtilitySansStrong100Style = "normal";
export const CdrTextUtilitySansStrong100Weight = "600";
export const CdrTextUtilitySansStrong100Spacing = "-0.08";
export const CdrTextUtilitySansStrong100Size = "12";
export const CdrTextUtilitySansStrong100Height = "16";
export const CdrTextUtilitySansStrong200Family = "Graphik, \"Graphik fallback\", \"Helvetica Neue\", sans-serif";
export const CdrTextUtilitySansStrong200Style = "normal";
export const CdrTextUtilitySansStrong200Weight = "600";
export const CdrTextUtilitySansStrong200Spacing = "-0.08";
export const CdrTextUtilitySansStrong200Size = "14";
export const CdrTextUtilitySansStrong200Height = "18";
export const CdrTextUtilitySansStrong300Family = "Graphik, \"Graphik fallback\", \"Helvetica Neue\", sans-serif";
export const CdrTextUtilitySansStrong300Style = "normal";
export const CdrTextUtilitySansStrong300Weight = "600";
export const CdrTextUtilitySansStrong300Spacing = "-0.08";
export const CdrTextUtilitySansStrong300Size = "16";
export const CdrTextUtilitySansStrong300Height = "22";
export const CdrTextUtilitySansStrong400Family = "Graphik, \"Graphik fallback\", \"Helvetica Neue\", sans-serif";
export const CdrTextUtilitySansStrong400Style = "normal";
export const CdrTextUtilitySansStrong400Weight = "600";
export const CdrTextUtilitySansStrong400Spacing = "-0.08";
export const CdrTextUtilitySansStrong400Size = "18";
export const CdrTextUtilitySansStrong400Height = "24";
export const CdrTextUtilitySansStrong500Family = "Graphik, \"Graphik fallback\", \"Helvetica Neue\", sans-serif";
export const CdrTextUtilitySansStrong500Style = "normal";
export const CdrTextUtilitySansStrong500Weight = "600";
export const CdrTextUtilitySansStrong500Spacing = "-0.16";
export const CdrTextUtilitySansStrong500Size = "20";
export const CdrTextUtilitySansStrong500Height = "26";
export const CdrTextUtilitySansStrong600Family = "Graphik, \"Graphik fallback\", \"Helvetica Neue\", sans-serif";
export const CdrTextUtilitySansStrong600Style = "normal";
export const CdrTextUtilitySansStrong600Weight = "600";
export const CdrTextUtilitySansStrong600Spacing = "-0.16";
export const CdrTextUtilitySansStrong600Size = "24";
export const CdrTextUtilitySansStrong600Height = "30";
export const CdrTextUtilitySansStrong700Family = "Graphik, \"Graphik fallback\", \"Helvetica Neue\", sans-serif";
export const CdrTextUtilitySansStrong700Style = "normal";
export const CdrTextUtilitySansStrong700Weight = "600";
export const CdrTextUtilitySansStrong700Spacing = "-0.16";
export const CdrTextUtilitySansStrong700Size = "28";
export const CdrTextUtilitySansStrong700Height = "36";
export const CdrTextUtilitySansStrong800Family = "Graphik, \"Graphik fallback\", \"Helvetica Neue\", sans-serif";
export const CdrTextUtilitySansStrong800Style = "normal";
export const CdrTextUtilitySansStrong800Weight = "600";
export const CdrTextUtilitySansStrong800Spacing = "-0.32";
export const CdrTextUtilitySansStrong800Size = "32";
export const CdrTextUtilitySansStrong800Height = "40";
export const CdrTextUtilitySerif200Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextUtilitySerif200Style = "normal";
export const CdrTextUtilitySerif200Weight = "400";
export const CdrTextUtilitySerif200Spacing = "-0.08";
export const CdrTextUtilitySerif200Size = "14";
export const CdrTextUtilitySerif200Height = "18";
export const CdrTextUtilitySerif300Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextUtilitySerif300Style = "normal";
export const CdrTextUtilitySerif300Weight = "400";
export const CdrTextUtilitySerif300Spacing = "-0.08";
export const CdrTextUtilitySerif300Size = "16";
export const CdrTextUtilitySerif300Height = "22";
export const CdrTextUtilitySerif400Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextUtilitySerif400Style = "normal";
export const CdrTextUtilitySerif400Weight = "400";
export const CdrTextUtilitySerif400Spacing = "-0.16";
export const CdrTextUtilitySerif400Size = "18";
export const CdrTextUtilitySerif400Height = "24";
export const CdrTextUtilitySerif500Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextUtilitySerif500Style = "normal";
export const CdrTextUtilitySerif500Weight = "400";
export const CdrTextUtilitySerif500Spacing = "-0.32";
export const CdrTextUtilitySerif500Size = "20";
export const CdrTextUtilitySerif500Height = "26";
export const CdrTextUtilitySerif600Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextUtilitySerif600Style = "normal";
export const CdrTextUtilitySerif600Weight = "400";
export const CdrTextUtilitySerif600Spacing = "-0.32";
export const CdrTextUtilitySerif600Size = "24";
export const CdrTextUtilitySerif600Height = "30";
export const CdrTextUtilitySerif700Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextUtilitySerif700Style = "normal";
export const CdrTextUtilitySerif700Weight = "400";
export const CdrTextUtilitySerif700Spacing = "-0.32";
export const CdrTextUtilitySerif700Size = "28";
export const CdrTextUtilitySerif700Height = "36";
export const CdrTextUtilitySerif800Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextUtilitySerif800Style = "normal";
export const CdrTextUtilitySerif800Weight = "400";
export const CdrTextUtilitySerif800Spacing = "-0.32";
export const CdrTextUtilitySerif800Size = "32";
export const CdrTextUtilitySerif800Height = "40";
export const CdrTextUtilitySerifStrong200Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextUtilitySerifStrong200Style = "normal";
export const CdrTextUtilitySerifStrong200Weight = "600";
export const CdrTextUtilitySerifStrong200Spacing = "-0.08";
export const CdrTextUtilitySerifStrong200Size = "14";
export const CdrTextUtilitySerifStrong200Height = "18";
export const CdrTextUtilitySerifStrong300Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextUtilitySerifStrong300Style = "normal";
export const CdrTextUtilitySerifStrong300Weight = "600";
export const CdrTextUtilitySerifStrong300Spacing = "-0.08";
export const CdrTextUtilitySerifStrong300Size = "16";
export const CdrTextUtilitySerifStrong300Height = "22";
export const CdrTextUtilitySerifStrong400Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextUtilitySerifStrong400Style = "normal";
export const CdrTextUtilitySerifStrong400Weight = "600";
export const CdrTextUtilitySerifStrong400Spacing = "-0.08";
export const CdrTextUtilitySerifStrong400Size = "18";
export const CdrTextUtilitySerifStrong400Height = "24";
export const CdrTextUtilitySerifStrong500Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextUtilitySerifStrong500Style = "normal";
export const CdrTextUtilitySerifStrong500Weight = "600";
export const CdrTextUtilitySerifStrong500Spacing = "-0.08";
export const CdrTextUtilitySerifStrong500Size = "20";
export const CdrTextUtilitySerifStrong500Height = "26";
export const CdrTextUtilitySerifStrong600Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextUtilitySerifStrong600Style = "normal";
export const CdrTextUtilitySerifStrong600Weight = "600";
export const CdrTextUtilitySerifStrong600Spacing = "-0.16";
export const CdrTextUtilitySerifStrong600Size = "24";
export const CdrTextUtilitySerifStrong600Height = "30";
export const CdrTextUtilitySerifStrong700Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextUtilitySerifStrong700Style = "normal";
export const CdrTextUtilitySerifStrong700Weight = "600";
export const CdrTextUtilitySerifStrong700Spacing = "-0.16";
export const CdrTextUtilitySerifStrong700Size = "28";
export const CdrTextUtilitySerifStrong700Height = "36";
export const CdrTextUtilitySerifStrong800Family = "Stuart, \"Stuart fallback\", Georgia, serif";
export const CdrTextUtilitySerifStrong800Style = "normal";
export const CdrTextUtilitySerifStrong800Weight = "600";
export const CdrTextUtilitySerifStrong800Spacing = "-0.16";
export const CdrTextUtilitySerifStrong800Size = "32";
export const CdrTextUtilitySerifStrong800Height = "40";
export const CdrTextItalicVariation = "'ital' 1";
export const CdrTextItalicStyle = "italic";
export const CdrTextStrongWeight = "700";
export const CdrMembershipVibrantColorTextButtonPrimaryHover = "#13352c";
export const CdrMembershipVibrantColorTextPrimary = "#13352c";
export const CdrMembershipVibrantColorTextLinkRest = "#13352C";
export const CdrMembershipVibrantColorTextLinkHover = "#13352C";
export const CdrMembershipVibrantColorTextLinkVisited = "#13352C";
export const CdrMembershipVibrantColorBackgroundButtonPrimaryRest = "#13352c";
export const CdrMembershipVibrantColorBackgroundButtonPrimaryActive = "#13352c";
export const CdrMembershipVibrantColorBackgroundPrimary = "#ffdc52";
export const CdrMembershipVibrantColorBorderButtonPrimaryRest = "#13352c";
export const CdrMembershipVibrantColorBorderButtonPrimaryActive = "#13352c";
export const CdrMembershipVibrantColorBorderButtonPrimaryHover = "#13352c";
export const CdrMembershipVibrantColorBorderLinkRest = "#13352C";
export const CdrMembershipVibrantColorBorderLinkHover = "#13352C";
export const CdrMembershipVibrantColorBorderLinkVisited = "#13352C";
export const CdrMembershipSubtleColorTextButtonPrimaryHover = "#13352c";
export const CdrMembershipSubtleColorTextPrimary = "#13352c";
export const CdrMembershipSubtleColorTextLinkRest = "#13352C";
export const CdrMembershipSubtleColorTextLinkHover = "#13352C";
export const CdrMembershipSubtleColorTextLinkVisited = "#13352C";
export const CdrMembershipSubtleColorBackgroundButtonPrimaryRest = "#13352c";
export const CdrMembershipSubtleColorBackgroundButtonPrimaryActive = "#13352c";
export const CdrMembershipSubtleColorBackgroundPrimary = "#bfb33e";
export const CdrMembershipSubtleColorBorderButtonPrimaryRest = "#13352c";
export const CdrMembershipSubtleColorBorderButtonPrimaryActive = "#13352c";
export const CdrMembershipSubtleColorBorderButtonPrimaryHover = "#13352c";
export const CdrMembershipSubtleColorBorderLinkRest = "#13352C";
export const CdrMembershipSubtleColorBorderLinkHover = "#13352C";
export const CdrMembershipSubtleColorBorderLinkVisited = "#13352C";
